import React, { useEffect, useState } from "react";
import {
  getallowancebonusType,
  getAllowancesBonuss,
  getDesignation,
  GetDynamicOptions,
  GetempLoanData,
  getfinancedetails,
  getLoanPaymentType,
  getLoanType,
  getPayScale,
  getWages,
  getWageTypes,
  InsertEmployeeFinanceDetails,
  InsertLoanBulk,
} from "../../services/dataService";
import Select from "react-select";
import toast from "react-hot-toast";
import { getSecureItem } from "../../services/SecureStorage";
const EmployeeFinanceDetails = ({ EmpId }) => {
  const UID = getSecureItem("userId");
  const [WageComponent, setWageComponent] = useState([]);
  const [PayScales, setPayScales] = useState([]);
  const [WageType, setWageType] = useState([]);
  const [selectedPayScale, setSelectedPayScale] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editedData, setEditedData] = useState(null);
  const [allowances, setAllowances] = useState([]);
  const [empLoanData, setEmpLoanData] = useState([]);
  const [LoanPaymentType, setLoanPaymentType] = useState([]);
  const [LoanType, setLoanType] = useState([]);
  const [AlloawnceType, setAlloawnceType] = useState([]);
  const [error, setError] = useState("");
  const [GetData, setGetData] = useState([]);
  const [DataId, setDataId] = useState("");
  const [selectedAllowance, setSelectedAllowance] = useState(null);
  const [basicpay, setbasicpay] = useState("");
  const [salaryOptions, setSalaryOptions] = useState([]);
  const [selectedIncrements, setSelectedIncrements] = useState([]);
  const [designation, setdesignation] = useState([]);
  const [selectedAllowances, setSelectedAllowances] = useState([]);
  const [currentAllowance, setCurrentAllowance] = useState(null);
  const [currentincrement, setcurrentincrement] = useState("");
  // new=========================
  const handleAllowanceSelect = (e) => {
    const allowanceId = e.target.value;
    const selected = allowances.find((item) => item.Id === allowanceId);

    // Check if already selected to avoid duplicates
    if (!selectedAllowances.some((item) => item.Id === allowanceId)) {
      setSelectedAllowances((prevAllowances) => [...prevAllowances, selected]);
    }
  };
  const handleRemoveAllowance = (allowanceId) => {
    setSelectedAllowances((prevAllowances) =>
      prevAllowances.filter((item) => item.Id !== allowanceId)
    );
  };


  const handleCurrentIncrementChange = (value) => {
    setcurrentincrement(value);
    const wageTypeId = WageType.find((el) => el.Name.toLowerCase() === "basic")?.Id;
    console.log("wageTypeId", wageTypeId);
    const payscaleee = PayScales.find((el) => (el.Id == selectedPayScale.Id))?.wageTypes?.find((el) => (el.WageTypeId == wageTypeId))?.Amount || 0
    console.log(payscaleee, "fghjkl")

    const amount = editedData?.wageTypes?.find(
      (el) => el?.WageTypeId == wageTypeId
    )?.Amount;


    console.log("value", value, "amount", amount);

    const basic = (parseFloat(value) || 0) + (parseFloat(payscaleee) || 0);

    console.log("basic", basic);

    setbasicpay(basic);
  };

  const handleAllowanceInputChange = (allowanceId, field, value) => {
    // Find the specific allowance we're updating
    setSelectedAllowances((prevAllowances) =>
      prevAllowances.map((allowance) => {
        if (allowance.Id === allowanceId) {
          // Special validation for NoOfTerms
          if (
            field === "NoOfTerms" &&
            value !== "" &&
            parseInt(value) >= allowance.AdvanceAmount
          ) {
            toast.error("Number of Terms must be less than the Advance Amount");
            return allowance; // Return unchanged if validation fails
          }

          // Return the updated allowance
          return {
            ...allowance,
            [field]: value,
          };
        }
        return allowance; // Return other allowances unchanged
      })
    );
  };

  const handleCheckboxChange = (id) => {
    setSelectedIncrements([id]);
    setEditedData((prev) => {
      const selectedIncrement = selectedPayScale.IncrementAmount.find(
        (el) => el.id === id
      );

      return {
        ...prev,
        SalaryAmount: selectedIncrement?.SalaryAmount || prev.SalaryAmount,
        IncrementAmountvalue:
          selectedIncrement?.IncrementAmount || prev.IncrementAmount,
      };
    });
  };

  const handleAllowanceChange = (e) => {
    const allowanceId = e.target.value;
    const selected = allowances.find((item) => item.Id === allowanceId);
    setSelectedAllowance(selected);
  };

  // const handleAllowanceInputChange = (field, value) => {
  //   if (
  //     field === "NoOfTerms" &&
  //     value !== "" &&
  //     parseInt(value) >= selectedAllowance.AdvanceAmount
  //   ) {
  //     toast.error("Number of Terms must be less than the Advance Amount");
  //     return;
  //   }

  //   setSelectedAllowance((prevState) => ({
  //     ...prevState,
  //     [field]: value,
  //   }));
  // };

  // Get allowance type label
  const getAllowanceTypeLabel = (typeId) => {
    const type = AlloawnceType?.find((al) => al.ID === typeId);
    return type ? type.type : "Unknown";
  };
  const fetchAllowancessbonus = async () => {
    try {
      const data = await getAllowancesBonuss(UID);
      setAllowances(data.data.data);
      setCurrentAllowance(data.data.data);
    } catch (error) {
      console.error("Error fetching allowances:", error);
    }
  };

  const fetchdesignation = async () => {
    try {
      const data = await getDesignation(UID);
      setdesignation(data.data.data);
    } catch (error) {
      console.error("Error fetching allowances:", error);
    }
  };

  const getFinanceDetailsee = async () => {
    try {
      const response = await getfinancedetails(EmpId);
      const data = response?.data;
      setGetData(data);
      if (!data) {
        console.error("No data found");
        return;
      }
    } catch (error) {
      console.error("Error fetching finance details:", error);
    }
  };

  const fetchLoanEmpData = async () => {
    try {
      const details = { EmpId: EmpId };
      const data = await GetempLoanData(details);
      setEmpLoanData(data.data.data);
    } catch (error) {
      console.error("Error fetching employee loan data:", error);
    }
  };

  const handlePayScaleChange = (e) => {
    const selected = PayScales.find((scale) => scale.Id === e.target.value);
    setSelectedPayScale(selected);
    setEditedData(null);
    setIsEditing(false);
    setbasicpay("");
    setcurrentincrement("");
  };

  const startEditing = () => {
    setEditedData({
      ...selectedPayScale,
      WageComponentId: JSON.parse(selectedPayScale?.WageComponentId || "[]"),
    });
    setIsEditing(true);
  };

  const cancelEditing = () => {
    setEditedData(null);
    setIsEditing(false);
  };

  const handleInputChange = (field, value) => {
    setEditedData((prev) => ({
      ...prev,
      [field]: value,
    }));

    console.log(editedData, "ffffffff");
  };

  const handleWageTypeChange = (index, field, value) => {
    setEditedData((prev) => {
      const newWageTypes = [...prev.wageTypes];
      newWageTypes[index] = { ...newWageTypes[index], [field]: value };
      return { ...prev, wageTypes: newWageTypes };
    });
  };


  const addWageType = () => {
    setEditedData((prev) => ({
      ...prev,
      wageTypes: [...prev.wageTypes, { WageTypeId: "", Amount: 0, isNew: true }],
    }));
  };
  // const addWageType = () => {
  //   setEditedData((prev) => ({
  //     ...prev,
  //     wageTypes: [...prev.wageTypes, { WageTypeId: "", Amount: 0 }],
  //   }));
  // };

  const removeWageType = (index) => {
    setEditedData((prev) => ({
      ...prev,
      wageTypes: prev.wageTypes.filter((_, i) => i !== index),
    }));
  };
  const [loading, setloading] = useState(false);

  const handleSave = async () => {
    setloading(true);
    try {
      const transformedWageComponentId = editedData.WageComponentId.map(
        (comp) => {
          if (typeof comp === "object" && comp.value) {
            return comp.value;
          }
          return comp;
        }
      );
      const wageTypeId = WageType.find((el) => (el.Name = "Basic")).Id;
      const directwage = selectedPayScale?.wageTypes.find((el) => (el.WageTypeId == wageTypeId)).Amount
      const wagetypeforsend = editedData.wageTypes.map((el) =>
        el.WageTypeId === wageTypeId
          ? {
            ...el,
            Amount:
              parseInt(basicpay) || directwage || 0,
          }
          : el
      );
      console.log("ell", wagetypeforsend);
      console.log("selected payscale", selectedPayScale);
      console.log("editedDatacheck", editedData);



      console.log(selectedPayScale, "select payscale check", "wageTypeId", wageTypeId, "asdas", directwage);
      console.log("editeddata asasa", editedData);



      const payload = {
        DataId: DataId ? DataId : 0,
        EmpId: EmpId,
        UserId: UID,
        ...editedData,
        ...selectedPayScale,
        IncrementAmountvalue: editedData?.IncrementAmountvalue || editedData?.IncrementAmount?.[0]?.IncrementAmount || 0,
        SalaryAmount: editedData?.SalaryAmount || editedData?.IncrementAmount?.[0]?.SalaryAmount || 0,
        payscale: {
          WageComponentId: transformedWageComponentId,
          WageTypes:
            GetData[0]?.length > 0 ? editedData.wageTypes : wagetypeforsend,
          IncrementAmount: editedData.IncrementAmount,
          SalaryGeneration: editedData.SalaryGeneration,
          DesignationId: editedData.DesignationId,
        },
        allowancesBonus: {
          selectedAllowances: selectedAllowances,
        },
        loans: {
          loanData: empLoanData,
          EmpId: EmpId,
          UserId: UID,
        },
        CategoryId: "",
        Currentbasicpay: basicpay ? basicpay : directwage,
        Narration: editedData.Narration,
      };

      console.log(editedData, "paffffffffff");
      console.log(payload, "paffffffffff");

      try {
        const response = await InsertEmployeeFinanceDetails(payload);
        const loanupdate = await InsertLoanBulk(payload.loans);
        console.log("payload.loans", payload.loans);
        toast.success("Finance Details Inserted Successfully");
        setloading(false);
        getFinanceDetailsee(EmpId)
        getfinancedetails(EmpId)

      } catch (error) {
        console.error("Error fetching Allowance Bonus Types:", error);
        setloading(false);
      }
      setloading(false);
      setIsEditing(false);
      setEditedData(null);
    } catch (error) {
      setloading(false);
      console.error("Error saving data:", error);
    }
  };

  const handleLoanTypeChange = (field, value, Id) => {
    const updatedLoanData = empLoanData.map((el) =>
      el.Id === Id ? { ...el, [field]: value, LoanType: value } : el
    );
    setEmpLoanData(updatedLoanData);
  };

  const handleChange = (index, event) => {
    const { name, value } = event.target;
    const newEmpLoanData = [...empLoanData];
    newEmpLoanData[index][name] = value;

    if (name === "DueAmount" || name === "Amount") {
      const amount = parseFloat(newEmpLoanData[index].Amount || 0);
      const dueAmount = parseFloat(newEmpLoanData[index].DueAmount || 0);

      if (dueAmount > amount) {
        setError("Due Amount cannot be greater than Amount");
      } else {
        setError("");
      }

      newEmpLoanData[index].NoofDues =
        dueAmount > 0 && dueAmount <= amount
          ? (amount / dueAmount).toFixed(0)
          : 0;
    }
    setEmpLoanData(newEmpLoanData);
  };
  const handleSalaryChange = (id, value) => {
    setSelectedPayScale((prevState) => {
      const updatedIncrements = prevState.IncrementAmount.map((inc) =>
        inc.id === id ? { ...inc, SalaryAmount: parseFloat(value) || 0 } : inc
      );

      return {
        ...prevState,
        IncrementAmount: updatedIncrements,
      };
    });

    setEditedData((prev) => ({
      ...prev,
      SalaryAmount: value,
    }));
  };

  const handleIncrementChange = (id, value) => {
    setSelectedPayScale((prevState) => {
      const updatedIncrements = prevState.IncrementAmount.map((inc) =>
        inc.id === id
          ? { ...inc, IncrementAmount: parseFloat(value) || 0 }
          : inc
      );

      return {
        ...prevState,
        IncrementAmount: updatedIncrements,
      };
    });

    setEditedData((prev) => ({
      ...prev,
      IncrementAmountvalue: value,
    }));
  };

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const [wagesRes, payScalesRes, wageTypesRes] = await Promise.all([
          getWages(UID),
          getPayScale(UID),
          getWageTypes(UID),
        ]);

        setWageComponent(wagesRes.data.data);
        setPayScales(payScalesRes.data.data);
        setWageType(wageTypesRes.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchAllData();
  }, [UID]);

  useEffect(() => {
    if (EmpId) {
      fetchLoanEmpData();
      fetchAllowancessbonus();
      fetchdesignation();
      getFinanceDetailsee();
    }
  }, [EmpId]);

  useEffect(() => {
    const fetchLoanPaymentType = async () => {
      try {
        const response = await getLoanPaymentType(UID);
        setLoanPaymentType(response.data.data);
      } catch (error) {
        console.error("Error fetching Loan Payment Types:", error);
      }
    };

    fetchLoanPaymentType();
  }, []);

  useEffect(() => {
    const fetchLoanType = async () => {
      try {
        const response = await getLoanType(UID);
        setLoanType(response.data.data);
      } catch (error) {
        console.error("Error fetching Loan Types:", error);
      }
    };

    fetchLoanType();
  }, []);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await GetDynamicOptions({
          optionType: "SalaryGenerationOption",
        });

        setSalaryOptions(response.data.data); // Make sure response structure is correct
      } catch (error) {
        console.error("Error fetching salary options:", error);
      }
    };

    fetchOptions();
  }, []);

  useEffect(() => {
    const fetchAllowancesBonusType = async () => {
      try {
        const response = await getallowancebonusType(UID);
        setAlloawnceType(response.data.data);
      } catch (error) {
        console.error("Error fetching Allowance Bonus Types:", error);
      }
    };

    fetchAllowancesBonusType();
  }, []);

  useEffect(() => {
    console.log("GetData:", GetData);

    // Early return if no data is available
    if (!GetData || GetData.length === 0) {
      console.log("GetData is empty or undefined");
      return;
    }

    // Get the first item from data
    const firstItem = GetData[0];
    console.log("First item in GetData:", firstItem);

    // Set data ID with null safety
    setDataId(firstItem?.Id || null);

    // Set selected pay scale with proper structure
    setSelectedPayScale({
      Id: firstItem?.PayScaleId || null,
      Narration: firstItem?.Narration || "",
      SalaryGeneration: firstItem?.SalaryGeneration || null,
      wageTypes: firstItem?.wageTypes || [],
      IncrementAmount: [
        {
          SalaryAmount: firstItem?.SalaryAmount || 0,
          IncrementAmount: firstItem?.IncrementAmount || 0,
        },
      ],
      WageComponentId: firstItem?.WageComponentId,
    });

    // Set selected increments safely
    setSelectedIncrements(firstItem?.SalaryAmount ? [firstItem.SalaryAmount] : []);

    // No need to proceed if WageType is not available
    if (!WageType || WageType.length === 0) {
      console.log("WageType is empty or undefined");
      return;
    }

    // Find basic wage type ID (case-insensitive comparison)
    const BasicId = WageType.find(
      (el) => el?.Name?.toUpperCase() === "BASIC"
    )?.Id;

    console.log('WageType data:', WageType);

    if (!BasicId) {
      console.log("BasicId is null or undefined");
      return;
    }

    console.log("Basic ID:", BasicId);

    // Find basic amount from wage types with strict equality check
    const BasicAmount = firstItem?.wageTypes?.find(
      (el) => el?.WageTypeId === BasicId
    )?.Amount || 0;

    console.log("Basic amount from wage types:", BasicAmount);

    // Check for current basic pay with multiple fallback options
    const possibleBasicPayValues = [
      firstItem?.Currentbasicpay,
      firstItem?.currentBasicPay,
      firstItem?.CurrentBasicPay,
      firstItem?.currentbasicpay,
      firstItem?.basic_pay_current,
      BasicAmount
    ];

    // Find first non-null, non-undefined value or default to 0
    const currentBasicPayValue = possibleBasicPayValues.find(
      value => value !== undefined && value !== null
    ) || 0;

    console.log("Selected current basic pay value:", currentBasicPayValue);

    // Set current increment and basic pay
    setcurrentincrement(currentBasicPayValue);
    setbasicpay(BasicAmount);

    // Set selected allowances with fallback to empty array
    setSelectedAllowances(firstItem?.selectedAllowances || []);

  }, [GetData, WageType]);

  // Add a second useEffect to monitor state changes
  useEffect(() => {
    console.log("Current increment state updated to:", currentincrement);
  }, [currentincrement]);

  // Add another useEffect to monitor basic pay changes
  useEffect(() => {
    console.log("Basic pay state updated to:", basicpay);
  }, [basicpay]);

  const currentYear = new Date().getFullYear();
  const futureYears = 5;
  const years = [];
  for (let year = currentYear; year <= currentYear + futureYears; year++) {
    years.push(year);
  }

  return (
    <div className="bg-white rounded-lg shadow-md max-w-4xl mx-auto p-6 max-h-[75vh] overflow-auto cus-scrollbar">
      <h2 className="text-xl font-bold mb-6">Employee Finance Details</h2>

      <div className="flex items-center gap-4 mb-6">
        <div className="flex-1">
          <label className="block mb-2 font-medium">Select Pay Scale</label>
          <select
            onChange={handlePayScaleChange}
            className="w-full p-2 border rounded focus:outline-none focus:border-blue-500"
            value={selectedPayScale?.Id}
          >
            <option value="">Select a payscale</option>
            {PayScales.map((scale, index) => (
              <option key={index} value={scale.Id}>
                {scale.Name}
              </option>
            ))}
          </select>
        </div>
        {selectedPayScale && !isEditing && (
          <button
            onClick={startEditing}
            className="px-4 py-2 mt-6 text-blue-600 border border-blue-600 rounded hover:bg-blue-50"
          >
            ✎ Edit Details
          </button>
        )}
      </div>

      {selectedPayScale && (
        <div className="space-y-6">
          <div className="rounded-lg ">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm mb-1">Narration</label>
                <input
                  type="text"
                  value={
                    isEditing
                      ? editedData["Narration"]
                      : selectedPayScale["Narration"]
                  }
                  onChange={(e) =>
                    handleInputChange("Narration", e.target.value)
                  }
                  disabled={!isEditing}
                  className="w-full p-2 border rounded focus:outline-none focus:border-blue-500"
                />
              </div>

              {/* Second Row: Salary Generation & Basic Pay */}
              <div>
                <label className="block text-sm mb-1">Salary Generation</label>
                <select
                  value={
                    isEditing
                      ? editedData["SalaryGeneration"]
                      : selectedPayScale["SalaryGeneration"]
                  }
                  onChange={(e) =>
                    handleInputChange("SalaryGeneration", e.target.value)
                  }
                  disabled={!isEditing}
                  className="w-full p-2 border rounded focus:outline-none focus:border-blue-500"
                >
                  {salaryOptions.map((option) => (
                    <option key={option.OptionName} value={option.OptionName}>
                      {option.OptionName}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm mb-1">
                  Current Basic Pay <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="profitCenterId"
                  name="profitCenterId"
                  placeholder="Current Basic Pay"
                  onWheel={(e) => e.target.blur()}
                  value={basicpay}
                  disabled
                  className="w-full p-2 border rounded focus:outline-none focus:border-blue-500"
                />
              </div>
            </div>
          </div>

          <div className="border rounded-lg">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Wage Types</h3>
              {isEditing && (
                <button
                  onClick={addWageType}
                  className="px-3 py-1 text-blue-600 border border-blue-600 rounded hover:bg-blue-50"
                >
                  + Add Wage Type
                </button>
              )}
            </div>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="p-3 text-left border-b">Wage Type</th>
                    <th className="p-3 text-left border-b">Amount</th>
                    {isEditing && (
                      <th className="p-3 text-center border-b">Action</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {(isEditing ? editedData : selectedPayScale)?.wageTypes?.map(
                    (wage, index) => (
                      <tr key={index}>
                        <td className="p-3 border-b">
                          <select
                            value={wage.WageTypeId}
                            onChange={(e) =>
                              handleWageTypeChange(
                                index,
                                "WageTypeId",
                                e.target.value
                              )
                            }
                            disabled={!wage.isNew} // Enable only for new wage types
                            className="w-full p-2 border rounded focus:outline-none focus:border-blue-500"
                          >
                            <option value="" disabled>
                              Select Wage type
                            </option>
                            {WageType.filter(
                              (type) =>
                                !editedData?.wageTypes?.some(
                                  (w, i) =>
                                    w.WageTypeId === type.Id && i !== index // Exclude current row
                                )
                            ).map((type) => (
                              <option key={type.Id} value={type.Id}>
                                {type.Name}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td className="p-3 border-b">
                          <input
                            type="number"
                            value={wage.Amount}
                            onChange={(e) =>
                              handleWageTypeChange(
                                index,
                                "Amount",
                                e.target.value
                              )
                            }
                            onWheel={(e) => e.target.blur()}
                            disabled={!wage.isNew} // Enable only for new wage types
                            className="w-full p-2 border rounded focus:outline-none focus:border-blue-500"
                          />
                        </td>
                        {isEditing && (
                          <td className="p-3 border-b text-center">
                            <button
                              onClick={() => removeWageType(index)}
                              className="text-red-500 hover:text-red-700"
                            >
                              🗑️
                            </button>
                          </td>
                        )}
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="mt-6">
            <h3 className="text-lg font-semibold">Increment Amount </h3>
            <div className="overflow-x-auto mt-2">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    {GetData?.length === 0 && (
                      <th className="p-3 text-left border-b">Select</th>
                    )}
                    <th className="p-3 text-left border-b">Salary Amount</th>
                    <th className="p-3 text-left border-b">Increment Amount</th>
                    <th className="p-3 text-left border-b">
                      Current Increment Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {selectedPayScale?.IncrementAmount?.map((inc) => (
                    <tr key={inc.id}>
                      {!GetData?.length ||
                        GetData[0]?.PayScaleId !== selectedPayScale.Id ? (
                        <td className="p-3 border-b text-center">
                          <input
                            type="checkbox"
                            checked={selectedIncrements.includes(inc.id)}
                            onChange={() => handleCheckboxChange(inc.id)}
                            className="w-4 h-4"
                            disabled={!isEditing}
                            onWheel={(e) => e.target.blur()}
                          />
                        </td>
                      ) : null}
                      <td className="p-3 border-b">
                        {GetData?.length > 0 && isEditing ? (
                          <input
                            type="number"
                            value={inc.SalaryAmount}
                            onChange={(e) =>
                              handleSalaryChange(inc.id, e.target?.value)
                            }
                            className="w-full p-2 border rounded"
                            onWheel={(e) => e.target.blur()}
                          />
                        ) : (
                          inc.SalaryAmount
                        )}
                      </td>
                      <td className="p-3 border-b">
                        {GetData.length > 0 && isEditing ? (
                          <input
                            type="number"
                            value={inc.IncrementAmount}
                            onChange={(e) =>
                              handleIncrementChange(inc.id, e.target.value)
                            }
                            className="w-full p-2 border rounded"
                            onWheel={(e) => e.target.blur()}
                          />
                        ) : (
                          inc.IncrementAmount
                        )}
                      </td>
                      {(selectedIncrements.includes(inc.id) ||
                        (GetData.length > 0)) && (
                          <td className="p-3 border-b">
                            <input
                              type="number"
                              value={currentincrement}
                              disabled={!isEditing}
                              onChange={(e) =>
                                handleCurrentIncrementChange(e.target.value)
                              }
                              className="w-full p-2 border rounded"
                              onWheel={(e) => e.target.blur()}
                            />
                          </td>
                        )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="border rounded-lg p-6">
            <h3 className="text-lg font-semibold mb-4">Wage Components</h3>
            <Select
              isMulti
              isDisabled={!isEditing}
              name="WageComponentId"
              options={WageComponent?.map((center) => ({
                value: center.Id,
                label: center.Name,
              }))}
              value={
                isEditing
                  ? (Array.isArray(editedData?.WageComponentId)
                    ? editedData?.WageComponentId
                    : JSON.parse(editedData?.WageComponentId || "[]")
                  ).map((id) => ({
                    value: id,
                    label:
                      WageComponent?.find((c) => c.Id === id)?.Name ||
                      "Unknown",
                  }))
                  : JSON.parse(selectedPayScale?.WageComponentId || "[]").map(
                    (id) => ({
                      value: id,
                      label:
                        WageComponent?.find((c) => c.Id === id)?.Name ||
                        "Unknown",
                    })
                  )
              }
              onChange={(selected) =>
                handleInputChange(
                  "WageComponentId",
                  selected.map((item) => item.value)
                )
              }
              className="w-full"
            />
          </div>
          {/* new======================= */}
          <div className="form-group flex flex-col">
            <label>Choose Allowance/Bonus Type </label>
            <select
              id="Allowancebonus"
              name="Allowancebonus"
              className="border p-2 rounded"
              value="" // Always reset to empty after selection
              disabled={!isEditing}
              onChange={handleAllowanceSelect}
            >
              <option value="" disabled>
                Select Allowance/Bonus
              </option>
              {allowances?.map((item) => (
                <option key={item.Id} value={item.Id}>
                  {item.Name}
                </option>
              ))}
            </select>

            {/* Display selected allowances */}
            {selectedAllowances.length > 0 && (
              <div className="mt-4">
                <h2 className="text-lg font-semibold mb-2">
                  Selected Allowances/Bonuses
                </h2>
                <div className="flex flex-wrap gap-2 mb-4">
                  {selectedAllowances.map((allowance) => (
                    <div
                      key={allowance.Id}
                      className="bg-gray-200 px-3 py-1 rounded-full flex items-center"
                    >
                      <span>{allowance.Name}</span>
                      <button
                        className="ml-2 text-red-500"
                        onClick={() => handleRemoveAllowance(allowance.Id)}
                        disabled={!isEditing}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Display allowance details for each selected allowance */}
            {selectedAllowances.map((allowance) => (
              <div key={allowance.Id} className="mt-6">
                <h1 className="text-xl font-bold mb-4 text-gray-800">
                  {allowance.Name} Details
                </h1>
                <div className="bg-white shadow-lg rounded-lg p-4 border border-gray-200">
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                    <div className="form-group flex flex-col">
                      <label className="block text-sm text-gray-500">
                        Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={allowance.Name}
                        onChange={(e) =>
                          handleAllowanceInputChange(
                            allowance.Id,
                            "Name",
                            e.target.value
                          )
                        }
                        className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                        disabled={!isEditing}
                      />
                    </div>

                    <div className="form-group flex flex-col">
                      <label className="block text-sm text-gray-500">
                        Type <span className="text-red-500">*</span>
                      </label>
                      <select
                        id={`paymentType-${allowance.Id}`}
                        name="LoanPaymentTypeName"
                        value={allowance.Type}
                        onChange={(e) =>
                          handleAllowanceInputChange(
                            allowance.Id,
                            "Type",
                            e.target.value
                          )
                        }
                        className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                        required
                        disabled={!isEditing}
                      >
                        <option value="" disabled>
                          Select Type
                        </option>
                        {AlloawnceType?.map((item) => (
                          <option key={item.ID} value={item.ID}>
                            {item.type}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group flex flex-col">
                      <label className="block text-sm text-gray-500">
                        Narration
                      </label>
                      <input
                        type="text"
                        value={allowance.Narration}
                        onChange={(e) =>
                          handleAllowanceInputChange(
                            allowance.Id,
                            "Narration",
                            e.target.value
                          )
                        }
                        className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                        disabled={!isEditing}
                      />
                    </div>

                    {/* Conditional fields based on type */}
                    {AlloawnceType.find((al) => al.ID === allowance.Type)
                      ?.type === "Advance" ? (
                      <>
                        <div className="form-group flex flex-col">
                          <label className="block text-sm text-gray-500">
                            Advance Amount{" "}
                            <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="number"
                            value={allowance.AdvanceAmount}
                            onChange={(e) =>
                              handleAllowanceInputChange(
                                allowance.Id,
                                "AdvanceAmount",
                                e.target.value
                              )
                            }
                            className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                            disabled={!isEditing}
                          />
                        </div>

                        <div className="form-group flex flex-col">
                          <label className="block text-sm text-gray-500">
                            No of Terms <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="number"
                            value={allowance.NoOfTerms}
                            onChange={(e) =>
                              handleAllowanceInputChange(
                                allowance.Id,
                                "NoOfTerms",
                                e.target.value
                              )
                            }
                            className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                            disabled={!isEditing}
                          />
                        </div>

                        <div className="form-group flex flex-col">
                          <label className="block text-sm text-gray-500">
                            Min Working Days{" "}
                            <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="number"
                            value={allowance.MinWorkingDays}
                            onChange={(e) =>
                              handleAllowanceInputChange(
                                allowance.Id,
                                "MinWorkingDays",
                                e.target.value
                              )
                            }
                            className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                            disabled={!isEditing}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="form-group flex flex-col">
                          <label className="block text-sm text-gray-500">
                            Amount <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="number"
                            value={allowance.Amount}
                            onChange={(e) =>
                              handleAllowanceInputChange(
                                allowance.Id,
                                "Amount",
                                e.target.value
                              )
                            }
                            className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                            disabled={!isEditing}
                          />
                        </div>

                        <div className="form-group flex flex-col">
                          <label className="block text-sm text-gray-500">
                            Min Working Days{" "}
                            <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="number"
                            value={allowance.MinWorkingDays}
                            onChange={(e) =>
                              handleAllowanceInputChange(
                                allowance.Id,
                                "MinWorkingDays",
                                e.target.value
                              )
                            }
                            className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                            disabled={!isEditing}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
         

          {empLoanData?.length > 0 ? (
            <div className="p-4 bg-gray-100 min-h-screen">
              <div>
                <h1 className="text-xl font-bold mb-4 text-gray-800">
                  Employee Loan Details
                </h1>

                <div className="grid gap-4">
                  {empLoanData?.map((el, index) => {
                    // Determine the current loan type name based on the selected LoanType ID
                    const currentLoanTypeName =
                      LoanType.find((type) => type.Id === el.LoanType)?.Name ||
                      el.LoanTypeName;

                    return (
                      <div
                        key={index}
                        className="bg-white shadow-lg rounded-lg p-4 border border-gray-200"
                      >
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                          {/* Always show Loan Name and Loan Type */}
                          <div>
                            <label className="block text-sm text-gray-500">
                              Loan Name <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              name="LoanName"
                              value={el.LoanName}
                              onChange={(e) => handleChange(index, e)}
                              disabled
                              className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                              required
                            />
                          </div>

                          <div className="form-group flex flex-col">
                            <label>
                              Loan Type <span className="text-red-500">*</span>
                            </label>
                            <select
                              id="loanType"
                              name="LoanType"
                              value={el.LoanType}
                              disabled
                              onChange={(e) => {
                                handleLoanTypeChange(
                                  "LoanType",
                                  e.target.value,
                                  el.Id
                                );
                                // Update the local state to trigger re-render
                                const updatedData = [...empLoanData];
                                updatedData[index].LoanType = e.target.value;
                                setEmpLoanData(updatedData);
                              }}
                              className="border p-2 rounded"
                              required
                            >
                              <option value="" disabled>
                                Select Loan Type
                              </option>
                              {LoanType?.map((item) => (
                                <option key={item.Id} value={item.Id}>
                                  {item.Name}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Show fields based on the currently selected loan type */}
                          {currentLoanTypeName === "Society Loan" ? (
                            <>
                              <div>
                                <label className="block text-sm text-gray-500">
                                  Amount <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="Amount"
                                  value={el.Amount}
                                  onChange={(e) => handleChange(index, e)}
                                  disabled
                                  className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                                  required
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-gray-500">
                                  Month <span className="text-red-500">*</span>
                                </label>
                                <select
                                  id="month"
                                  name="month"
                                  value={el.month}
                                  disabled
                                  onChange={(e) => handleChange(index, e)}
                                  required
                                  className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                                >
                                  <option value="" disabled selected>
                                    Select Month
                                  </option>
                                  {[
                                    "January",
                                    "February",
                                    "March",
                                    "April",
                                    "May",
                                    "June",
                                    "July",
                                    "August",
                                    "September",
                                    "October",
                                    "November",
                                    "December",
                                  ].map((month) => (
                                    <option key={month} value={month}>
                                      {month}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div>
                                <label className="block text-sm text-gray-500">
                                  Year <span className="text-red-500">*</span>
                                </label>

                                <select
                                  className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                                  name="Year"
                                  value={el.Year}
                                  onChange={(e) => handleChange(index, e)}
                                  required
                                  disabled
                                >
                                  <option value="" disabled>
                                    Year
                                  </option>
                                  {years.map((year) => (
                                    <option key={year} value={year}>
                                      {year}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </>
                          ) : (
                            <>
                              <div>
                                <label className="block text-sm text-gray-500">
                                  Branch <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="Branch"
                                  value={el.Branch}
                                  onChange={(e) => handleChange(index, e)}
                                  disabled
                                  className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                                  required
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-gray-500">
                                  Number <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="Number"
                                  value={el.Number}
                                  onChange={(e) => handleChange(index, e)}
                                  disabled
                                  className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                                  required
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-gray-500">
                                  Amount <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="Amount"
                                  value={el.Amount}
                                  onChange={(e) => handleChange(index, e)}
                                  disabled
                                  className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                                  required
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-gray-500">
                                  Due Amount{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="DueAmount"
                                  value={el.DueAmount}
                                  onChange={(e) => handleChange(index, e)}
                                  disabled
                                  className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                                  required
                                />
                                {error && (
                                  <p className="text-sm text-red-600">
                                    {error}
                                  </p>
                                )}
                              </div>
                              <div>
                                <label className="block text-sm text-gray-500">
                                  No of Dues{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="NoofDues"
                                  value={el.NoofDues}
                                  onChange={(e) => handleChange(index, e)}
                                  disabled
                                  className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                                  required
                                />
                              </div>
                              <div className="form-group flex flex-col">
                                <label>
                                  Payment Type{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <select
                                  id="paymentType"
                                  name="PaymentType"
                                  value={el.PaymentType || ""}
                                  onChange={(e) =>
                                    handleLoanTypeChange(
                                      "PaymentType",
                                      e.target.value,
                                      el.Id
                                    )
                                  }
                                  className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                                  required
                                  disabled
                                >
                                  <option value="" disabled>
                                    Select Payment Type
                                  </option>
                                  {LoanPaymentType?.map((item) => (
                                    <option key={item.Id} value={item.Id}>
                                      {item.Name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div>
                                <label className="block text-sm text-gray-500">
                                  Due Date{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="date"
                                  name="DueDate"
                                  value={
                                    el.DueDate ? el.DueDate.split("T")[0] : ""
                                  }
                                  onChange={(e) => handleChange(index, e)}
                                  disabled
                                  className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                                  required
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-gray-500">
                                  Start Date{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="date"
                                  name="StartDate"
                                  value={
                                    el.StartDate
                                      ? el.StartDate.split("T")[0]
                                      : ""
                                  }
                                  onChange={(e) => handleChange(index, e)}
                                  disabled
                                  className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                                  required
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-gray-500">
                                  End Date{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="date"
                                  name="EndDate"
                                  value={
                                    el.EndDate ? el.EndDate.split("T")[0] : ""
                                  }
                                  onChange={(e) => handleChange(index, e)}
                                  disabled
                                  className="w-full px-3 py-2 border rounded-md bg-gray-50 text-gray-700"
                                  required
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : (
            <div></div>
          )}

          {isEditing && (
            <div className="flex justify-end gap-4 mt-6">
              <button
                onClick={cancelEditing}
                className="px-4 py-2 text-gray-600 border border-gray-600 rounded hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 btn btn-primary"
                disabled={loading}
              >
                Save Changes
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default EmployeeFinanceDetails;
